<!-- 非标道路压实工艺参数-->
<template>
  <div>
    <div class="currency">
        <div class="header"><span class="hText">压实工艺参数</span></div>
        <div class="content">
            <div class="setBlock">
                <div style="flex:4">
                    <div style="width:100%;height:45px;margin-top:10px;display:flex">
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft">选择压实设备</div>
                                <div class="itemRight">
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.equipCheckStr}}</span>
                                    <el-select v-if="isLook" v-model="equipCodeName" placeholder="请选择"  class="infoShow selectShort" multiple collapse-tags>
                                        <el-option
                                            v-for="item in equipmentList"
                                            :key="item.code"
                                            :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width:100%;height:100px;display:flex;margin-top:10px;">
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft" title="设定安全区域和施工区域之间的间隙">边界间隙</div>
                                <div class="itemRight">
                                    <div class='companyShow'>M</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.specialAreaRolling.specialAreaRollingBoundaryRemainGap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.specialAreaRolling.specialAreaRollingBoundaryRemainGap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                            <div class="itemLeft" title="设定路障和施工区域之间的间隙">路障间隙</div>
                                <div class="itemRight">
                                    <div class='companyShow'>M</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.specialAreaRolling.specialAreaRollingBarrierRemainGap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.specialAreaRolling.specialAreaRollingBarrierRemainGap.value}}</span>
                                </div>
                            </div>
                        </div>    
                        <div style="flex:1" >
                            <div class="item_type">
                                <div class="itemLeft">搭接距离</div>
                                <div class="itemRight">
                                    <div class='companyShow'>M</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.specialAreaRolling.specialAreaRollingLengthOverlap.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.specialAreaRolling.specialAreaRollingLengthOverlap.value}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="item_type">
                            <div class="itemLeft">前进速度</div>
                                <div class="itemRight">
                                    <div class='companyShow'>km/h</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.specialAreaRolling.specialAreaRollingForwardSpeed.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.specialAreaRolling.specialAreaRollingForwardSpeed.value}}</span>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft">是否承接上次施工进度</div>
                                <div class="itemRight">
                                    <!-- <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.normalParam.loadLastC0.value"></el-input> -->
                                    <el-select v-if="isLook" v-model="workSetInfoValue.normalParam.loadLastC0.value" placeholder="请选择"  class="infoShow">
                                        <el-option
                                        v-for="item in booleanList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.normalParam.loadLastC0.value==0?'否':'是'}}</span>
                                </div>
                            </div>  
                            <div class="item_type">
                                <div class="itemLeft">后退速度</div>
                                <div class="itemRight">
                                    <div class='companyShow'>km/h</div>
                                    <el-input v-if="isLook" class="infoShow" v-model="workSetInfoValue.specialAreaRolling.specialAreaRollingBackSpeed.value"></el-input>
                                    <span v-if="!isLook" class="infoShow">{{workSetInfoValue.specialAreaRolling.specialAreaRollingBackSpeed.value}}</span>
                                </div>
                            </div>
                        </div>
                        <div style="flex:1">
                            <div class="item_type">
                                <div class="itemLeft"></div>
                                <div class="itemRight">
                                    <div class='companyShow'></div>
                                    <!-- <el-input v-if="isLook" class="infoShow"></el-input> -->
                                    <span v-if="!isLook" class="infoShow"></span>
                                </div>
                            </div> 
                        </div>
                    </div>
                    <div style="width:100%;height:90px;padding-top:10px;">
                        <div style="flex:1">
                            <div class="item_type" style="margin-top:10px;">
                                <div class="itemLeft" title="在所有路径上均一来一回才算一遍">碾压遍数</div>
                                <div class="itemRight" style="">
                                    <div v-if="isLook">
                                        <el-select @change="changeRoll2Order" v-model="secondRoll_1" placeholder="请选择"  class="infoShowShot">
                                            <el-option
                                                v-for="item in rollNumList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <span v-if="!isLook" class="infoShow">{{this.rollNumList[workSetInfoValue.specialAreaRolling.specialAreaRollingNum.value].label}}</span>
                                </div>
                            </div>
                            <div class="item_type">
                                <div class="itemLeft">震动序列</div>
                                <div class="itemRight">
                                    <div v-if="!isLook">
                                        <span  class="orderShow1" v-for="(item,index) in specialAreaRollingOrderArrFont"  :key='index'>
                                            <span v-for="(i,k) in item" :key='k'>
                                                <span>{{i}}<span>{{k==0?" | ":""}}</span></span>
                                            </span>
                                        </span>
                                    </div>
                                    <div v-if="isLook">
                                        <draggable v-model="specialAreaRollingOrderArr" @update="datadragEnd" v-bind = "{draggable:'.drag-item',animation:500}">
                                                <transition-group>
                                                    <div v-for="(element,i) in specialAreaRollingOrderArr" :key="i+1" class = "drag-item">
                                                      <div class="dragitemselect">
                                                        <el-select @change="changeRollShakOrder(i,0)" v-model="specialAreaRollingOrderArr[i][0]" placeholder="请选择"  class="infoShowShot">
                                                            <el-option
                                                                v-for="item in forwardCraftSettingList"
                                                                :key="item.value"
                                                                :label="item.label"
                                                                :value="item.value">
                                                            </el-option>
                                                        </el-select>|
                                                        <el-select @change="changeRollShakOrder(i,1)" v-model="specialAreaRollingOrderArr[i][1]" placeholder="请选择"  class="infoShowShot">
                                                            <el-option
                                                                v-for="item in backCraftSettingList"
                                                                :key="item.value"
                                                                :label="item.label"
                                                                :value="item.value">
                                                            </el-option>
                                                        </el-select>
                                                      </div>
                                                    </div>
                                                </transition-group>
                                        </draggable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
//   import { getWorkConfig,getWorkConfigDetails } from '../../utils/api'
  import draggable from 'vuedraggable'
  export default {
    name      : 'app',
    data() {
      return {
        // url: require('../../images/all/setImg.png'),
        // 通用判断列表
        booleanList:[
            {
                label: '否',
                value: 0
            },{
                label: '是',
                value: 1
            }
        ],
        // 震动模式
        craftSettingList:[
            {
                label: '静压',
                value: 0
            },{
                label: '小震',
                value: 1
            },{
                label: '大震',
                value: 2
            }
        ],
        // 前进震动模式
        forwardCraftSettingList:[
            {
                label: '前进静压',
                value: 0
            },{
                label: '前进小震',
                value: 1
            },{
                label: '前进大震',
                value: 2
            }
        ],
        // 后退震动模式
        backCraftSettingList:[
            {
                label: '后退静压',
                value: 0
            },{
                label: '后退小震',
                value: 1
            },{
                label: '后退大震',
                value: 2
            }
        ],
        equipCodeName:[],
        // 前进震动数组
        forwardCraftSettingListArr:[ '前进静压', '前进小震', '前进大震'],
        // 后退震动数组
        backCraftSettingListArr:['后退静压','后退小震','后退大震'],
        craftSettingObj:{
            0: '静压',
            1: '小震',
            2: '大震',
        },
        //遍数
        rollNumList:[{
            label: '无',
            value: 0
        },{
            label: '一遍',
            value: 1
        },{
            label: '二遍',
            value: 2
        },{
            label: '三遍',
            value: 3
        },{
            label: '四遍',
            value: 4
        },{
            label: '五遍',
            value: 5
        },{
            label: '六遍',
            value: 6
        },{
            label: '七遍',
            value: 7
        },{
            label: '八遍',
            value: 8
        },],
        secondRoll_1: 1,
        // secondRoll_2: 1,
        // secondRoll_3: 1,
        // 泊车策略
        strategyForParkingList: [],
        // 整体数据
        workSetInfoValue: this.workSetInfo,

        startArr:[],
        endArr:[],
        count:0,
        specialAreaRollingNumArr: [],//碾压遍数数组
        specialAreaRollingOrderNumArr: [],//碾压顺序数字数组
        specialAreaRollingOrderArr:[],//碾压顺序文字数组
        specialAreaRollingOrderArrFont:[],
        equipCodeRoller1nd:[],
        equipCodeRoller2nd:[],
        equipCodePaver:[],
        isTypechange:0,
        isequipchange:0,
      }
    },
    props: {
        workSetInfo:{
            type: Object,
            default: function(){
                return {workSetInfo:{}}
            }
        },
        equipmentList:{
            type: Array,
            default: function(){
                return []
            }
        },
        isLook: {
            type: Boolean,
            required: false
        },
        setParameterChange: {
            type: String
        },
        workType:{
            type: Number
        }
    },
    computed:{},
    beforeCreate(){
        
    },
    created(){
        // console.log('jinlai')
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    },
    mounted(){
        console.log(this.workSetInfoValue,"workSetInfoValueworkSetInfoValueworkSetInfoValue")
        // this.specialAreaRollingNumArr=this.workSetInfoValue.specialAreaRolling.specialAreaRollingNum.value.split(",")
        this.specialAreaRollingOrderArr=[];
        this.specialAreaRollingOrderArrFont=[];
        this.secondRoll_1=this.workSetInfoValue.specialAreaRolling.specialAreaRollingNum.value*1
        this.specialAreaRollingOrderNumArr=this.workSetInfoValue.specialAreaRolling.specialAreaRollingOrder.value.split(",").map(item=>item*1)
        // this.workSetInfoValue.equipCodeName=[...this.equipmentList];
        // this.secondRoll_1=this.specialAreaRollingNumArr[0]*1;
        // this.secondRoll_2=this.specialAreaRollingNumArr[1]*1;
        // this.secondRoll_3=this.specialAreaRollingNumArr[2]*1;

        for(let i=0;i<this.specialAreaRollingOrderNumArr.length;i++){
            if(i%2==0){
                this.specialAreaRollingOrderArr.push([this.specialAreaRollingOrderNumArr[i]])
                this.specialAreaRollingOrderArrFont.push([this.forwardCraftSettingListArr[this.specialAreaRollingOrderNumArr[i]]])
            }else{
                this.specialAreaRollingOrderArr[parseInt(i/2)].push(this.specialAreaRollingOrderNumArr[i])
                this.specialAreaRollingOrderArrFont[parseInt(i/2)].push(this.backCraftSettingListArr[this.specialAreaRollingOrderNumArr[i]])
            }
            
        }
        console.log(this.specialAreaRollingOrderArrFont,this.specialAreaRollingOrderArr,"this.specialAreaRollingOrderArrFont")
        // this.changeRoll2Order();
    },
    methods: {
        getdata (evt) {
            console.log(evt.draggedContext.element.text)
        },
        datadragEnd (evt) {
            evt.preventDefault();
            console.log('拖动前的索引 :' + evt.oldIndex)
            console.log('拖动后的索引 :' + evt.newIndex)
            console.log(this.specialAreaRollingOrderArr);
            let arr = []
            // for(let i=0;i<this.specialAreaRollingOrderArr.length;i++){
            //     if(this.specialAreaRollingOrderArr[i] == '静压'){
            //         arr.push('0')
            //     }else if(this.specialAreaRollingOrderArr[i] == '小震'){
            //         arr.push('1')
            //     }else if(this.specialAreaRollingOrderArr[i] == '大震'){
            //         arr.push('2')
            //     }
            // }
            for(let i=0;i<this.specialAreaRollingOrderArr.length;i++){
                for(let j=0;j<this.specialAreaRollingOrderArr[i].length;j++){
                    arr.push( this.specialAreaRollingOrderArr[i][j])
                }
            }
            this.specialAreaRollingOrderNumArr = arr
        },
        
        checkArray: function(para, arr) {
            let processArr = arr.filter(function(value) {
                return value == para;
            });

            return processArr.length;  // 这里返回数组长度或者相应处理
        },
        changeRoll2Order: function(){ //获取碾压顺序的数组
            let setArr = []
            // let setNum = []
            for(let i=0;i<this.secondRoll_1;i++){
                setArr.push([0,0])
                // setNum.push('0')
            }
            // for(let i=0;i<this.secondRoll_2;i++){
            //     setArr.push('小震')
            //     setNum.push('1')
            // }
            // for(let i=0;i<this.secondRoll_3;i++){
            //     setArr.push('大震')
            //     setNum.push('2')
            // }
            this.specialAreaRollingOrderArr = setArr
            let arr = []
            for(let i=0;i<this.specialAreaRollingOrderArr.length;i++){
                for(let j=0;j<this.specialAreaRollingOrderArr[i].length;j++){
                    arr.push( this.specialAreaRollingOrderArr[i][j])
                }
            }
            this.specialAreaRollingOrderNumArr = arr
            // this.specialAreaRollingOrderNumArr = setNum
            console.log('specialAreaRollingOrderNumArr:',this.specialAreaRollingOrderArr)
        },
        changeRollShakOrder(i,num){
            console.log(i,num)
            let arr = []
            for(let i=0;i<this.specialAreaRollingOrderArr.length;i++){
                for(let j=0;j<this.specialAreaRollingOrderArr[i].length;j++){
                    arr.push( this.specialAreaRollingOrderArr[i][j])
                }
            }
            this.specialAreaRollingOrderNumArr = arr
        },
        // getEquipName: function(arr1,arr2){
        //     let equipCheckList = []
        //     for(let i=0;i<arr1.length;i++){
        //         for(let j=0;j<arr2.length;j++){
        //             if(arr1[i] == arr2[j].code){
        //                 equipCheckList.push(arr2[j].name)
        //             }
        //         }
        //     }
        //     let equipCheckStr = equipCheckList.join(",")

        //     return equipCheckStr
        // }
    },
    watch : {
        equipmentList:{
                deep: true,
                immediate: true,
                handler(newV){
                    if(this.isequipchange==0){
                        this.isequipchange=1
                        console.log('workType:2',newV)
                    }else{
                        this.equipCodeName=[]
                        console.log('workType:1',newV)
                    }
                    
                }
            },
        workType:{
            deep: true,
            immediate: true,
            handler(newV){
                
                if(this.isTypechange==0){
                    this.isTypechange=1
                    console.log('workType:3',newV)
                }else{
                    this.workSetInfoValue.equipCodeList=[]
                    this.workSetInfoValue.equipCodeName=[]
                    this.equipmentList=[]
                    this.equipCodeName=[]
                    console.log('workType:4',newV)
                }
            }
        },
    workSetInfo:{
        deep: true,
        immediate: true,
        handler(newV){
            console.log(newV,newV.equipCheckStr,'newwwwwwwwwww')
            this.workSetInfoValue=newV;
            if(typeof(newV.equipCheckStr)=="string" ){
                    this.equipCodeName=newV.equipCheckStr.split(",")
                }
            // if(typeof(newV.equipCodeList)=="string" ){
            //     this.workSetInfoValue.equipCodeName=newV.equipCodeList.split(",")
            // }else if(typeof(newV.equipCodeList)=="object"){
            //     this.workSetInfoValue.equipCodeName=newV.equipCodeList
            // }
            // console.log(this.workSetInfoValue.equipCodeName,"this.workSetInfoValue.equipCodeName")
            if(newV.specialAreaRollingOrderArr){
                this.specialAreaRollingOrderArr = newV.specialAreaRollingOrderArr
                this.secondRoll_1= this.checkArray('静压',this.specialAreaRollingOrderArr)
                this.secondRoll_2= this.checkArray('小震',this.specialAreaRollingOrderArr)
                this.secondRoll_3= this.checkArray('大震',this.specialAreaRollingOrderArr)

                if(newV.setCode){
                    console.log('setCodejinlai')
                    this.$set(this.workSetInfoValue.rollerParam2nd,'fRTimesStr',newV.rollerParam2nd.fRTimesStr)
                    this.$set(this.workSetInfoValue.rollerParam2nd,'fRTimesArr',newV.rollerParam2nd.fRTimesArr)
                }
                this.specialAreaRollingOrderNumArr = newV.specialAreaRolling.specialAreaRollingOrder.value.split(",").map(item=>item*1)
                console.log("经过这里")
            }else if(Object.keys(newV).length>0){
                this.specialAreaRollingOrderArr=[];
                this.specialAreaRollingOrderArrFont=[];
                this.secondRoll_1=this.workSetInfoValue.specialAreaRolling.specialAreaRollingNum.value*1
                this.specialAreaRollingOrderNumArr=this.workSetInfoValue.specialAreaRolling.specialAreaRollingOrder.value.split(",").map(item=>item*1)

                for(let i=0;i<this.specialAreaRollingOrderNumArr.length;i++){
                    if(i%2==0){
                        this.specialAreaRollingOrderArr.push([this.specialAreaRollingOrderNumArr[i]])
                        this.specialAreaRollingOrderArrFont.push([this.forwardCraftSettingListArr[this.specialAreaRollingOrderNumArr[i]]])
                    }else{
                        this.specialAreaRollingOrderArr[parseInt(i/2)].push(this.specialAreaRollingOrderNumArr[i])
                        this.specialAreaRollingOrderArrFont[parseInt(i/2)].push(this.backCraftSettingListArr[this.specialAreaRollingOrderNumArr[i]])
                    }
                }
            }
            if(newV.setCode == 'init'){
                console.log('setCodejinlai',newV)
                this.workSetInfoValue=newV;
                this.specialAreaRollingOrderArr=[];
                this.specialAreaRollingOrderArrFont=[];
                this.secondRoll_1=this.workSetInfoValue.specialAreaRolling.specialAreaRollingNum.value*1
                this.specialAreaRollingOrderNumArr=this.workSetInfoValue.specialAreaRolling.specialAreaRollingOrder.value.split(",").map(item=>item*1)

                for(let i=0;i<this.specialAreaRollingOrderNumArr.length;i++){
                    if(i%2==0){
                        this.specialAreaRollingOrderArr.push([this.specialAreaRollingOrderNumArr[i]])
                        this.specialAreaRollingOrderArrFont.push([this.forwardCraftSettingListArr[this.specialAreaRollingOrderNumArr[i]]])
                    }else{
                        this.specialAreaRollingOrderArr[parseInt(i/2)].push(this.specialAreaRollingOrderNumArr[i])
                        this.specialAreaRollingOrderArrFont[parseInt(i/2)].push(this.backCraftSettingListArr[this.specialAreaRollingOrderNumArr[i]])
                    }
                }
            }
        }
      },
      
      setParameterChange(newV){
        console.log(newV,this.equipCodeName,"new or old")
        let arr=[]
        for(let i=0;i<this.equipCodeName.length;i++){
            for(let j=0;j<this.equipmentList.length;j++){
                if(this.equipCodeName[i]==this.equipmentList[j].code){
                    arr.push(this.equipmentList[j].name)
                }
            }
        }
        console.log(arr)
        this.workSetInfoValue.equipCodeName=this.equipCodeName
        this.workSetInfoValue.equipCheckStr=arr.join("、");
        this.workSetInfoValue.specialAreaRolling.specialAreaRollingNum.value=this.secondRoll_1;
        this.workSetInfoValue.specialAreaRolling.specialAreaRollingOrder.value=this.specialAreaRollingOrderNumArr.join(",");
        console.log(this.workSetInfoValue,"childfun5")
        this.$emit("childFun5",this.workSetInfoValue)
      }
    },
    components:{
        draggable
    }
  }
</script>
<style lang="scss">
.currency{
        .el-input__inner{
            padding-right: 40px !important;
        }
        .infoShow{
            width: 100%;
            height: 100%;
            border: 0;
            color: #555555;
            font-size: 14px;
            // padding-left: 46px;
        }
    }
 .selectShort{
     width: 254px !important;
 }
 .dragitemselect{
     display: flex;
     justify-content: center;
     border: 1px solid #222222;
     border-radius: 20px !important;
     >div{
        margin-left:0px !important;
        margin-right:0px !important;
     }
     .el-input__suffix{
         display: none !important;
         border-radius: 20px !important;
     }
     .el-input__inner{
         padding: 0px !important;
         text-align: center;
         border: none !important;
         border-radius: 0px !important;
         height: 34px !important;
         width: 66px !important;
     }
 }
</style>
<style lang="scss" scoped="">
    .currency{
        width: 100%;
        height: auto;
        margin-top: 14px;
        // background-color: aqua;
        border:1px solid rgba(225, 225, 225, 1);
    }
    .header{
        width: 100%;
        height: 50px;
        background:rgba(242,242,245,1);
        border-bottom:1px solid rgba(225, 225, 225, 1);
        position: relative;
        .hText{
            display: inline-block;
            position: absolute;
            line-height: 17px;
            height: 17px;
            color: 16px;
            top: 17px;
            left: 16px;
            font-weight:bold;
            color:rgba(85,85,85,1);
        }
    }
    .content{
        width: 95%;
        height: auto;
    }
    .line{
        height: 1px;
        width: 94.5%;
        margin: 0 auto;
        background-color: #E1E1E1;
    }
    .setBlock{
        display: flex;
        height: 312px;
        width: 100%;
        .item_type{
                flex: 1;
                margin-top:10px;
                .itemLeft{
                    width:144px;
                    height: 45px;
                    float: left;
                    line-height: 45px;
                    text-align: right;
                    color: #888888;
                    font-size: 13px;
                }
                .itemRight{
                    height: 100%;
                    height: 45px;
                    line-height: 45px;
                    padding-left: 39px;
                    overflow: hidden;
                    color: #222222;
                    font-size: 14px;
                    position: relative;
                    .orderShow{
                        display: inline-block;
                        width:45px;
                        height:22px;
                        background:rgba(225,235,250,1);
                        font-size:14px;
                        color: #2273F8;
                        text-align: center;
                        line-height: 22px;
                        margin-left: 6px;
                    }
                    .orderShow1{
                    display: inline-block;
                    width:150px;
                    height:36px;
                    // background:rgba(225,235,250,1);
                    font-size:14px;
                    border-radius: 18px;
                    // color: #2273F8;
                    text-align: center;
                    line-height: 36px;
                    margin-left: 6px;
                    border: 1px solid #222;
                    margin-right: 12px;
                    }
                    .companyShow{
                        font-size:14px;
                        color: #222222;
                        width: 40px;
                        line-height: 45px;
                        height: 45px;
                        text-align: center;
                        position: absolute;
                        top: 0;
                        right: 0;
                        z-index: 100;
                    }
                    .infoShowShot{
                        width: 90px;
                        margin-left: 8px;
                        margin-right: 8px;
                    }
                }
            }
    }
    
    .test{
        border:1px solid #ccc;
    }
    .drag-item{
        width: 180px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        // background: #E1EBFA;
        color: #2273F8;
        margin-right: 12px;
        margin-top: 6px;
        cursor: pointer;
        float: left;
    }
    .ghostClass{
        opacity: 1;
    }
    .bottom{
        width: 200px;
        height: 50px;
        position: relative;
        background: blue;
        top:2px;
        left: 2px;
        transition: all .5s linear;
    }
</style>